<template>
  <div class="login__flex-wrapper">
    <div class="login__wrapper">
      <div class="login-form">
        <form class="login-form__wrapper">
          <img
            src="../../assets/img/saliency.png"
            alt
            class="login-form__logo"
          />
          <p>Log in to have an access to the dashboard</p>
          <input
            v-model="username"
            type="text"
            placeholder="Enter your username"
            class="login-form__input"
          />
          <div class="login-form__eye-box">
            <input
              v-model="password"
              :type="passwordType"
              placeholder="Enter your password"
              class="login-form__input"
            />
            <i class="login-form__eye ti-eye" @click="toggleVisibility"></i>
          </div>

          <button @click.prevent="logInRequest" class="login-form__submit">
            Log In
          </button>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import FailedLoginTemplate from "../../pages/Notifications/FailedLoginTemplate";
import SuccessLoginTemplate from "../../pages/Notifications/SuccessLoginTemplate";

export default {
  name: "login",
  data() {
    return {
      username: "",
      password: "",
      passwordType: "password"
    };
  },
  methods: {
    toggleVisibility() {
      this.passwordType = this.passwordType === "text" ? "password" : "text";
    },
    logInRequest() {
      const requestBody = {
        username: this.username,
        password: this.password
      };

      this.$store
        .dispatch("login", requestBody)
        .then(() => {
          this.$router.replace({ path: "datapoints" });
          // this.$store.dispatch("openLoginModal");
        })
        .catch(err => {
          this.notifyVue("danger");
          console.log(err);
        });
    },
    notifyVue(type) {
      this.$notify({
        component:
          type === "success" ? SuccessLoginTemplate : FailedLoginTemplate,
        icon: type === "success" ? "ti-gift" : "ti-alert",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: type
      });
    }
  }
};
</script>
<style lang="scss">
.login {
  &__wrapper {
    width: 80%;
    max-width: 700px;
    max-height: 400px;
    margin-top: 100px;
    background-image: url("../../assets/img/background-login.jpg");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    display: flex;
    justify-content: flex-end;
    position: relative;

    @media only screen and (min-width: 481px) and (max-width: 768px) {
      width: 400px;
    }

    @media only screen and (min-width: 320px) and (max-width: 480px) {
      width: 95%;
    }

    p {
      text-align: center;
      color: white;
    }

    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: #000;
      opacity: 0.5;
    }
  }

  &__flex-wrapper {
    width: 100%;
    height: calc(100vh - 75px);
    display: flex;
    justify-content: center;
  }
}

.login-form {
  background: linear-gradient(0.35turn, #343536, #595e66);
  width: 60%;
  height: 400px;
  position: relative;

  @media only screen and (min-width: 481px) and (max-width: 768px) {
    width: 70%;
  }

  @media only screen and (min-width: 320px) and (max-width: 480px) {
    width: 100%;
  }

  &__wrapper {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 400px;
    width: 100%;
  }

  &__logo {
    width: 200px;
    margin-bottom: 20px;
  }

  &__input {
    border: none;
    border-radius: 2px;
    margin: 10px;
    width: 240px;
    padding: 4px 10px;

    @media only screen and (min-width: 320px) and (max-width: 480px) {
      width: 180px;
    }
  }

  &__submit {
    background-color: #949799;
    border: none;
    border-radius: 8px;
    width: 200px;
    padding: 8px;
    margin-top: 45px;
    color: white;

    &:hover {
      background-color: rgba(255, 255, 255, 0.3);
    }

    @media only screen and (min-width: 320px) and (max-width: 480px) {
      width: 180px;
    }
  }

  &__eye-box {
    position: relative;
  }

  &__eye {
    position: absolute;
    top: 13px;
    right: 15px;
    padding: 5px;
    cursor: pointer;
  }
}
</style>
